import React from 'react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, BarElement, ArcElement, Tooltip, Legend, Filler,
} from 'chart.js';
import { Line, Bar, Doughnut } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);

const fmtMoneyTip = v => `S/ ${parseFloat(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2 })}`;

/** Línea simple (ej. Ventas por día) */
export function LineChart({ labels, data, color = '#0ea5e9', height = 250 }) {
  const chartData = {
    labels,
    datasets: [{
      data, borderColor: color, backgroundColor: `${color}22`,
      borderWidth: 2, pointRadius: 0, pointHoverRadius: 4, fill: true, tension: 0.3,
    }],
  };
  const options = {
    responsive: true, maintainAspectRatio: false, animation: false,
    plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => fmtMoneyTip(ctx.raw) } } },
    scales: {
      x: { grid: { display: false }, ticks: { color: '#94a3b8', font: { size: 10.5 } } },
      y: { grid: { color: '#f1f5f9' }, ticks: { color: '#94a3b8', font: { size: 10.5 }, callback: v => v >= 1000 ? `${v / 1000}k` : v } },
    },
  };
  return <div style={{ height, width: '100%' }}><Line data={chartData} options={options} /></div>;
}

/** Barras — soporta 1 o varias series (ej. Ingresos/Costo/Utilidad) */
export function BarChart({ labels, series, height = 250 }) {
  const chartData = {
    labels,
    datasets: series.map(s => ({
      label: s.label, data: s.data, backgroundColor: s.color, borderRadius: 3, maxBarThickness: 28,
    })),
  };
  const options = {
    responsive: true, maintainAspectRatio: false, animation: false,
    plugins: {
      legend: { display: series.length > 1, position: 'bottom', labels: { boxWidth: 10, font: { size: 11 }, color: '#64748b' } },
      tooltip: { callbacks: { label: ctx => `${ctx.dataset.label}: ${fmtMoneyTip(ctx.raw)}` } },
    },
    scales: {
      x: { grid: { display: false }, ticks: { color: '#94a3b8', font: { size: 10.5 } } },
      y: { grid: { color: '#f1f5f9' }, ticks: { color: '#94a3b8', font: { size: 10.5 }, callback: v => v >= 1000 ? `${v / 1000}k` : v } },
    },
  };
  return <div style={{ height, width: '100%' }}><Bar data={chartData} options={options} /></div>;
}

const PALETA = ['#0ea5e9', '#16a34a', '#d97706', '#dc2626', '#7c3aed', '#0891b2', '#db2777', '#65a30d'];

/** Donut — recibe [{label, value}] */
export function DoughnutChart({ items, colors, height = 220 }) {
  const palette = colors || PALETA;
  const chartData = {
    labels: items.map(i => i.label),
    datasets: [{
      data: items.map(i => i.value),
      backgroundColor: items.map((_, i) => palette[i % palette.length]),
      borderWidth: 0,
    }],
  };
  const options = {
    responsive: true, maintainAspectRatio: false, animation: false,
    plugins: {
      legend: { position: 'right', labels: { boxWidth: 10, font: { size: 10.5 }, color: '#64748b' } },
      tooltip: { callbacks: { label: ctx => `${ctx.label}: ${fmtMoneyTip(ctx.raw)}` } },
    },
    cutout: '62%',
  };
  return <div style={{ height, width: '100%' }}><Doughnut data={chartData} options={options} /></div>;
}
